const store = {
    namespaced: true,
    state() {
        return {
            promotions: [],
            products: [],
            promo: {}
        };
    },
    getters: {
        getPromotions(state) {
            return state.promotions;
        },
        getPromo(state) {
            return state.promo;
        },
        getProducts(state) {
            return state.products;
        },
        getPromotionsForMainPage(state) {
            return state.promotions?.filter(promotion => promotion?.is_active).slice(0, 3) || [];
        }
    },
    mutations: {
        setProducts(state, products) {
            state.products = products;
        },
        addProducts(state, products) {
            state.products = state.products.concat(products);
        },
        setPromotions(state, promotions) {
            state.promotions = promotions;
        },
        setPromo(state, promo) {
            state.promo = promo;
        }
    },
    actions: {
        async fetchPromotions({ commit }) {
            try {
                const promotions = await this.$axios.$get('general/promotions');
                commit('setPromotions', promotions);
            } catch (e) {
                console.log(e);
            }
        }
    }
};

export default store;
